var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('custom-field-boolean', {
    attrs: {
      "disabled": !_vm.isEditing,
      "customField": {
        label: _vm.$t('objects.contract.insurance.hasGapCoverage')
      }
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.hasGapCoverage');
      }
    },
    model: {
      value: _vm.localDetails.hasGapCoverage,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "hasGapCoverage", $$v);
      },
      expression: "localDetails.hasGapCoverage"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.insurance.fullComprehensiveDeductible'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.fullComprehensiveDeductible');
      }
    },
    model: {
      value: _vm.localDetails.fullComprehensiveDeductibleFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "fullComprehensiveDeductibleFormable", _vm._n($$v));
      },
      expression: "localDetails.fullComprehensiveDeductibleFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.insurance.partialCoverageDeductible'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.partialCoverageDeductible');
      }
    },
    model: {
      value: _vm.localDetails.partialCoverageDeductibleFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "partialCoverageDeductibleFormable", _vm._n($$v));
      },
      expression: "localDetails.partialCoverageDeductibleFormable"
    }
  }), _c('custom-field-boolean', {
    attrs: {
      "disabled": !_vm.isEditing,
      "customField": {
        label: _vm.$t('objects.contract.insurance.hasRoadsideAssistance')
      }
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.hasRoadsideAssistance');
      }
    },
    model: {
      value: _vm.localDetails.hasRoadsideAssistance,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "hasRoadsideAssistance", $$v);
      },
      expression: "localDetails.hasRoadsideAssistance"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.insurance.maxTowingAmount'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.maxTowingAmount');
      }
    },
    model: {
      value: _vm.localDetails.maxTowingAmountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "maxTowingAmountFormable", _vm._n($$v));
      },
      expression: "localDetails.maxTowingAmountFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.insurance.maxRoadsideCoverageAmount'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.maxRoadsideCoverageAmount');
      }
    },
    model: {
      value: _vm.localDetails.maxRoadsideCoverageAmountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "maxRoadsideCoverageAmountFormable", _vm._n($$v));
      },
      expression: "localDetails.maxRoadsideCoverageAmountFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.insurance.rentalCarDailyRate'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.rentalCarDailyRate');
      }
    },
    model: {
      value: _vm.localDetails.rentalCarDailyRateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "rentalCarDailyRateFormable", _vm._n($$v));
      },
      expression: "localDetails.rentalCarDailyRateFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.insurance.rentalCarMaxDays'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.rentalCarMaxDays');
      }
    },
    model: {
      value: _vm.localDetails.rentalCarMaxDaysFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "rentalCarMaxDaysFormable", _vm._n($$v));
      },
      expression: "localDetails.rentalCarMaxDaysFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.insurance.maxBreakdownAssistanceAmount'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.insurance.maxBreakdownAssistanceAmount');
      }
    },
    model: {
      value: _vm.localDetails.maxBreakdownAssistanceAmountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "maxBreakdownAssistanceAmountFormable", _vm._n($$v));
      },
      expression: "localDetails.maxBreakdownAssistanceAmountFormable"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }